import { AxiosInstance } from "axios";
import { PublicDataResponseService } from "./PublicData.type";

export default class PublicDataService {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async getPublicData(): Promise<PublicDataResponseService> {
    const url: string = "/public-data";
    return this.axios.get(url);
  }
}
